import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AcceptInvitePage } from './pages/AcceptInvitePage';
import { AdminPage } from './pages/AdminPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { DevLoaderPage } from './pages/DevLoaderPage';
import { LoginPage } from './pages/LoginPage';

export function App(): ReactNode {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Il percorso deve restare allineato a buildInviteUrl() lato API. */}
      <Route path="/invito" element={<AcceptInvitePage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      {/* Il brand vive nell'URL: la vista è condivisibile e Indietro funziona. */}
      <Route
        path="/brand/:slug"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      {/* Cambio password volontario: aperto a qualunque utente collegato. */}
      <Route
        path="/password"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />
      {/* Pannello riservato all'admin: la barriera vera è comunque nell'API. */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allow={['admin']}>
            <AdminPage />
          </ProtectedRoute>
        }
      />
      {/* Anteprima del loader: solo in sviluppo, il build di produzione non
          contiene né la rotta né la pagina. */}
      {import.meta.env.DEV ? <Route path="/dev/loader" element={<DevLoaderPage />} /> : null}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
